export default __webpack_public_path__ + "static/media/heart_icon_inactive_black.6fdb2766.svg";